import { render, staticRenderFns } from "./ShippingDeliveryService.vue?vue&type=template&id=ee8e6292&scoped=true&"
var script = {}
import style0 from "./ShippingDeliveryService.vue?vue&type=style&index=0&id=ee8e6292&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8e6292",
  null
  
)

export default component.exports